import React, { FC } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import {
	IconChevronUpThick,
	IconChevronDownThick,
	Button,
} from '@sololearnorg/sol';

import { MaterialRenderer } from '../../MaterialRenderer/MaterialRenderer';
import { ILPAngularCourseContentData } from '../../../../../api/private/learn-engine-api/landing-page-api.interface';

import s from './AngularCourseContent.scss';

type Props = {
	data: ILPAngularCourseContentData;
};

export const AngularCourseContent: FC<Props> = ({ data }) => {
	useStyles(s);
	const [expandedGroups, setExpandedGroups] = React.useState<string[]>([
		'Angular',
	]);

	const onExpand = (title: string) => {
		if (expandedGroups.includes(title)) {
			setExpandedGroups(
				expandedGroups.filter((group) => group !== title),
			);
		} else {
			setExpandedGroups([...expandedGroups, title]);
		}
	};

	return (
		<div className="angular-content">
			<div className="angular-content__container">
				<div className="angular-content__wrapper">
					<h4 className="angular-content__title">{data.title}</h4>
					<p className="angular-content__description">
						{data.description}
					</p>
					{data.courses.map((course: any) => (
						<>
							{course.jumpTo && (
								<div className="angular-content__jump">
									<div className="angular-content__hr" />
									<p className="angular-content__jump-text">
										{course.jumpTo}
									</p>
									<div className="angular-content__hr" />
								</div>
							)}
							<div className="angular-content__expandable">
								<div
									className="angular-content__expandable-bar"
									onClick={() => onExpand(course.title)}
								>
									<h5 className="angular-content__course-title">
										{course.title}
									</h5>
									{expandedGroups.includes(course.title) ? (
										<IconChevronUpThick
											size={20}
											className="le-module__dropdown-icon"
										/>
									) : (
										<IconChevronDownThick
											size={20}
											className="le-module__dropdown-icon"
										/>
									)}
								</div>
								{expandedGroups.includes(course.title) && (
									<MaterialRenderer
										materialInfo={
											course.subtree.materialInfo
										}
										hideCertificate
										hideHeader
										isExpanded
										className="angular-content__material"
									>
										{course.subtree.children}
									</MaterialRenderer>
								)}
							</div>
							<div
								className={`angular-content__divider ${
									expandedGroups.includes(course.title)
										? 'hidden'
										: ''
								}`}
							/>
						</>
					))}
					<a className="angular-content__button-container">
						<Button
							className="angular-content__button"
							onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
						>
							Start free course
						</Button>
					</a>
				</div>
			</div>
		</div>
	);
};
